import React from 'react';
import { Input, Select } from 'formsy-react-components';
import { timezoneOptions, jobTypeConstants } from '../../utils';
import { buildEditTime } from '../../state/jobs/time-utils';

export const RequiredJobInfo = React.createClass({
  render() {
    const { job, languages, jobType } = this.props;
    const languageOptions = [
      {
        value: '',
        label: 'Please Select a language'
      },
      ...languages
    ];

    const start_time_utc = job.get('start_time_utc');
    const end_time_utc = job.get('end_time_utc');
    const [displayStartDate, startTime] = buildEditTime(
      start_time_utc,
      'US/Eastern'
    );
    const [, endTime] = buildEditTime(end_time_utc, 'US/Eastern');

    return (
      <div>
        <Select
          label="Time Zone"
          name="time_zone"
          options={timezoneOptions}
          value="US/Eastern"
          required
        />
        <Input
          label={
            jobType === jobTypeConstants.TRANSLATION ? 'Deadline Date' : 'Date'
          }
          type="date"
          name="date"
          value={displayStartDate}
          labelClassName="small-12"
          elementWrapperClassName="small-12"
          required
        />
        <Input
          label={
            jobType === jobTypeConstants.TRANSLATION
              ? 'Deadline Time'
              : 'Start Time'
          }
          type="time"
          name="start_time"
          value={startTime}
          labelClassName="small-12"
          elementWrapperClassName="small-12"
          required
        />
        {jobType === jobTypeConstants.TRANSLATION ? null : (
          <Input
            label="End Time"
            type="time"
            name="end_time"
            value={endTime || ''}
            labelClassName="small-12"
            elementWrapperClassName="small-12"
          />
        )}
        <Select
          label="Language"
          options={languageOptions}
          name="language"
          required
          value={job.get('language') || ''}
        />
      </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./src/components/jobs/required-job-info.jsx
 **/